import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from './locales/en'
import es from './locales/es'
import fr from './locales/fr'
import ar from './locales/ar'
import de from './locales/de'
import zh from './locales/zh'

Vue.use(VueI18n)

const messages = {
  en,
  es,
  fr,
  ar,
  de,
  zh
}

export const i18n = new VueI18n({
  locale: window.navigator.language.split('-')[0],
  fallbackLocale: 'en',
  messages
})
